export default "__VITE_ASSET__B03O7jAz__"